import {AUTH_LOGIN, AUTH_LOGOUT} from '@/store/modules/authentication/types';
import {DISABLE_LOADING, ENABLE_LOADING, GET_LOADING} from '@/store/types';
import * as axios from 'axios';
import {mapActions, mapGetters} from 'vuex';
import {AUTH_GET_TOKEN, AUTH_GET_USERNAME} from '../../../store/modules/authentication/types';

export const httpMixin = {
  computed: {
    ...mapGetters({
      isLoading: GET_LOADING,
      userName: AUTH_GET_USERNAME,
      userToken: AUTH_GET_TOKEN
    }),

    http() {
      const instance = axios.create({
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${this.userToken}`,
          'x-userName': this.userName
        }
      });

      instance.interceptors.request.use(this._requestSuccess, this._requestError);
      instance.interceptors.response.use(this._responseSuccess, this._responseError);

      return instance;
    },

    httpFile() {
      const instance = axios.create({
        responseType: 'arraybuffer',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${this.userToken}`,
          'x-userName': this.userName
        }
      });

      instance.interceptors.request.use(this._requestSuccess, this._requestError);
      instance.interceptors.response.use(this._responseSuccess, this._responseError);

      return instance;
    },

    httpAuth() {
      const instance = axios.create({
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      instance.interceptors.request.use(this._requestSuccess, this._requestError);
      instance.interceptors.response.use(this._responseSuccess, this._responseError);

      return instance;
    }
  },

  methods: {
    ...mapActions({
      authLogin: AUTH_LOGIN,
      authLogout: AUTH_LOGOUT,
      enableLoading: ENABLE_LOADING,
      disableLoading: DISABLE_LOADING
    }),

    _requestSuccess(req) {
      this.enableLoading();
      return req;
    },

    _requestError(err) {
      this.disableLoading();
      return Promise.reject(err);
    },

    _responseSuccess(res) {
      this.disableLoading();
      return Promise.resolve(res);
    },

    _responseError(err) {
      if (err.request.status === 401) {
        this.authLogout();
      }

      this.disableLoading();
      return Promise.reject(err);
    }
  }
};
